import { updateMemberPersonalDetails } from '@vista/omnichannel-components-domain';
import { mapMemberFormDataToPersonalDetails } from '../../../subcomponents/member-form/mappers/map-member-form-data-to-personal-details';
export const updatePersonalDetailsFromFormData = async (formData) => {
    const personalDetails = mapMemberFormDataToPersonalDetails(formData);
    return updateMemberPersonalDetails(personalDetails, formData.captcha);
};
